export const doColumns = [
  {
    field: "lineNo",
    headerName: "Line No",
    align: "right",
    left: 0,
    width: 100,
  },
  {
    field: "orderNumber",
    headerName: "Order Number",
    left: 100,
    width: 160,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    left: 260,
    width: 150,
  },
  {
    field: "custOrdNbr",
    headerName: "Customer Order Number",
    width: 220,
    // align: "right",
    // left: 290,
    // left: 220
  },
  {
    field: "pickslipNumber",
    headerName: "Pickslip Number",
    width: 220,
    // align: "right",
    // left: 450,
    // left: 220
  },
  {
    field: "packType",
    headerName: "Pack Type",
    // sortable: false,
    width: 100,
    //flex: 0.35,
  },
  {
    field: "orderQuantity",
    headerName: "Order Quantity",
    // sortable: false,
    width: 130,
    //flex: 0.35,
    align: "right",
  },
  {
    field: "shippedQuantity",
    headerName: "Shipped Quantity",
    // sortable: false,
    width: 150,
    //flex: 0.35,
    align: "right",
  },
  {
    field: "uom",
    headerName: "UOM",
    // sortable: false,
    width: 120,
    //flex: 0.3,
    // valueGetter: (col) => {
    //     return col?.value?.label ?? "";
    // },
  },
  {
    field: "quantity",
    headerName: "Quantity",
    // sortable: false,
    width: 120,
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    // sortable: false,
    width: 100,
    //flex: 0.35,
  },
  {
    field: "currencyCode",
    headerName: "Currency Code",
    // sortable: false,
    width: 150,
    //flex: 0.45,
  },
  {
    field: "unitPrice",
    headerName: "Unit Price",
    // sortable: false,
    width: 120,
    align: "right",
    //flex: 0.45,
  },
  {
    field: "costPrice",
    headerName: "Cost Price",
    // sortable: false,
    width: 120,
    align: "right",
    //flex: 0.45,
  },
  {
    field: "discountAmount",
    headerName: "Discount Amount",
    // sortable: false,
    width: 150,
    align: "right",
    //flex: 0.45,
  },
  {
    field: "taxAmount",
    headerName: "Tax Amount",
    // sortable: false,
    width: 120,
    align: "right",
  },
  {
    field: "mln",
    headerName: "MLN",
    // sortable: false,
    width: 120,
    //flex: 0.45,
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    // sortable: false,
    width: 150,
    //flex: 0.45,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    // sortable: false,
    width: 150,
    //flex: 0.45,
  },
  {
    field: "remark",
    headerName: "Remark",
    // sortable: false,
    width: 200,
    //flex: 0.45,
  },
];
